import React from "react";
import { cn } from "../../lib/utils";
import { DEFAULT_FONT_FAMILY } from "../../config/fontConfig";
import { COLORS } from "../../config/colors";


export type ButtonVariant =
  | "primary"
  | "secondary"
  | "outline"
  | "cancel"
  | "danger"
  | "reset"
  | "ghost";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: "sm" | "md" | "lg";
  children: React.ReactNode;
}

const baseClasses =
  "inline-flex items-center justify-center rounded-[6px] transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed";

const sizeClasses = {
  sm: "text-sm 3xl:text-[16px] px-2 py-1.5",
  md: "text-base 3xl:text-[18px] px-4 py-2",
  lg: "text-lg 3xl:text-[20px] px-8 py-2.5",
};

const variantClasses = {
  primary: "text-white",
  secondary: "text-white",
  outline: "border  border-[#1E1F26] text-[#1E1F26]",
  cancel: "border border-gray-800 text-gray-800",
  danger: "bg-red-600 text-white",
  reset: "bg-blue-500 text-white text-xs rounded-full px-3 py-1",
  ghost: "bg-transparent hover:opacity-80",
};

const variantBg: Partial<Record<ButtonVariant, string>> = {
  primary: COLORS.buttonActive,
  secondary: COLORS.buttonInactive,
  ghost: "transparent",
};

const variantColor: Partial<Record<ButtonVariant, string>> = {
  ghost: COLORS.buttonActive,
};

const Button: React.FC<ButtonProps> = ({
  variant = "primary",
  size = "md",
  children,
  className,
  style,
  ...props
}) => {
  return (
    <button
      className={cn(
        baseClasses,
        sizeClasses[size],
        variantClasses[variant],
        className
      )}
      style={{
        fontFamily: DEFAULT_FONT_FAMILY,
        backgroundColor: variantBg[variant],
        color: variantColor[variant],
        ...style,
      }}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;